import { render, staticRenderFns } from "./ApplyMessage.vue?vue&type=template&id=732201fc&scoped=true"
import script from "./ApplyMessage.vue?vue&type=script&lang=js"
export * from "./ApplyMessage.vue?vue&type=script&lang=js"
import style0 from "./ApplyMessage.vue?vue&type=style&index=0&id=732201fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732201fc",
  null
  
)

export default component.exports